import api from './api';

// Product Services
export const productService = {
  // Get all products with pagination
  getProducts: async (params = {}) => {
    const response = await api.get('/products', { params });
    return response.data;
  },

  // Get product by ID
  getProductById: async (id) => {
    const response = await api.get(`/products/${id}`);
    return response.data;
  },

  // Create new product
  createProduct: async (productData) => {
    const response = await api.post('/products', productData);
    return response.data;
  },

  // Update product
  updateProduct: async (id, productData) => {
    const response = await api.put(`/products/${id}`, productData);
    return response.data;
  },

  // Delete product
  deleteProduct: async (id) => {
    const response = await api.delete(`/products/${id}`);
    return response.data;
  },

  // Get all products (alias for getProducts)
  getAllProducts: async (params = {}) => {
    const response = await api.get('/products', { params });
    return response.data;
  },

  // Toggle product publish status
  togglePublish: async (id, isActive) => {
    const response = await api.patch(`/products/${id}/publish`, { isActive });
    return response.data;
  },

  // Download Facebook catalog CSV for a product
  downloadFacebookCsv: async (id) => {
    const response = await api.get(`/products/${id}/facebook-csv`, {
      responseType: 'blob',
    });
    return response;
  },

  // Download combined Facebook catalog CSV for selected products
  downloadBulkFacebookCsv: async (productIds) => {
    const response = await api.post(
      '/products/facebook-csv/bulk',
      { productIds },
      { responseType: 'blob' }
    );
    return response;
  }
};
